import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { 
	getAnimalLineageDetails
} from "../../../../redux/farmanimal/farmAnimalState";
import Lineage from "./Lineage";

const PedigreeMatrix = ({getLineage, recordData, requesting, success, userDetails, ...props}) => {
	const { recordId } = props;  	
	
	useEffect(() => {		
		getLineage(recordId);
	}, [recordId, getLineage]);
	
	return (
		<div className="flex">
			<div className="flex flex-row-reverse gap-10">
				<Lineage recordData={recordData} gender={recordData?.gender_name}/>
			</div>
		</div>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmAnimal.lineage?.data,
	requesting: state.farmAnimal.lineage?.requesting,
	success: state.farmAnimal.lineage?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getLineage: (id) => dispatch(getAnimalLineageDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PedigreeMatrix);